import React from 'react'
import { createRoot } from 'react-dom/client'
import './styles/main.scss'
import App from './App'

createRoot(document.getElementById('root')).render(<App />)